var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cr_wrap"},[_c('img',{staticClass:"cr_img",attrs:{"src":("" + (_vm.apiObj.VUE_APP_BASE_CDN+_vm.imgPtah))}})])}
var staticRenderFns = []

export { render, staticRenderFns }